import React from 'react';
import StyleGuide from 'components/commercetools-ui/organisms/guides/style';

const StyleGuideTastic = () => {
  return <StyleGuide />;
};

export default StyleGuideTastic;
